import React from "react";
import { Link } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  UncontrolledCollapse,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
  Button
} from "reactstrap";
import { scroller } from "react-scroll";
class DemoNavbar extends React.Component {
  componentDidMount() {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
  }
  state = {
    collapseClasses: "",
    collapseOpen: false
  };

  onExiting = () => {
    this.setState({
      collapseClasses: "collapsing-out"
    });
  };

  onExited = () => {
    this.setState({
      collapseClasses: ""
    });
  };
  scrollTo(e,name) {
    scroller.scrollTo(name, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    })
  }

  render() {
    return (
      <>
        <header className="header-global">
          <Navbar
            className="navbar-main navbar-transparent headroom"
            expand="lg"
            id="navbar-main"
            
          >
            <Container>
              <NavbarBrand className="mr-lg-5" to="/" tag={Link}>
                <img
                  alt="..."
                  src={require("../../assets/img/brand/BigTiqvahLogo.png")}
                  style={{width:'100px', height: '60px'}}
                />
              </NavbarBrand>
              <Button outline  id="navbar_globa" color="#046307">
                <i className="fa fa-bars d-lg-none" />
                {/* <span  style={{ color:'#046307' }}><i className="fa fa-bars d-lg-none" /></span> */}
              </Button>
              <UncontrolledCollapse
                toggler="#navbar_globa"
                navbar
                className={this.state.collapseClasses}
                onExiting={this.onExiting}
                onExited={this.onExited}
              >
                <Nav className="navbar-nav-hover align-items-lg-center" navbar>
                  <NavItem>
                      <NavLink
                        className="nav-link-icon"
                        href="#"
                        target="_blank"
                      >
                        <i className="ni ni-ui-04 d-lg-none mr-1" />
                      <span className="nav-link-inner--text text-darker" onClick={(e) => this.scrollTo(e,'team')}><b>About Us</b></span>
                      </NavLink>
                  </NavItem>
                  <UncontrolledDropdown nav>
                    <DropdownToggle nav>
                      <i className="ni ni-collection d-lg-none mr-1" />
                      <span className="nav-link-inner--text text-darker"><b>Categories</b></span>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem tag={Link} onClick={(e) => this.scrollTo(e,'apparel')}>
                        Tiqvah Apparel
                      </DropdownItem>
                      <DropdownItem  tag={Link} onClick={(e) => this.scrollTo(e,'electronics')}>
                        Electronics
                      </DropdownItem>
                      <DropdownItem  tag={Link} onClick={(e) => this.scrollTo(e,'songwriting')}>
                        Song Writing
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Nav>
                <Nav className="align-items-lg-center ml-lg-auto" navbar>
                <NavItem>
                      <NavLink
                        className="nav-link-icon"
                        target="_blank"
                      >
                        <i className="ni ni-ui-04 d-lg-none mr-1" />
                      <span className="nav-link-inner--text text-darker" onClick={(e) => this.scrollTo(e,'contactus')}><b>Contact Us</b></span>
                      </NavLink>
          
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://www.facebook.com/tiqvahope"
                      id="tooltip333589074"
                      target="_blank"
                    >
                      <i className="fa fa-facebook-square text-darker"/>
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Facebook
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip333589074">
                      Like us on Facebook
                    </UncontrolledTooltip>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://www.instagram.com/tiqvahapparel"
                      id="tooltip356693867"
                      target="_blank"
                    >
                      <i className="fa fa-instagram text-darker"/>
                      <span className="nav-link-inner--text d-lg-none ml-2" >
                        Instagram
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip356693867">
                      Follow us on Instagram
                    </UncontrolledTooltip>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className="nav-link-icon"
                      href="https://twitter.com/tiqvahope"
                      id="tooltip184698705"
                      target="_blank"
                    >
                      <i className="fa fa-twitter-square text-darker"/>
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Twitter
                      </span>
                    </NavLink>
                    <UncontrolledTooltip delay={0} target="tooltip184698705">
                      Follow us on Twitter
                    </UncontrolledTooltip>
                  </NavItem>
                </Nav>
              </UncontrolledCollapse>
            </Container>
          </Navbar>
        </header>
      </>
    );
  }
}

export default DemoNavbar;
